module.exports = __webpack_public_path__ + "static/media/immunity.4bc979c2.jpg";